<template>
  <v-card>
    <v-toolbar color="kbGreen"
               dark
               flat
               dense>
      <v-toolbar-title>
        Iniciar conversación
      </v-toolbar-title>

      <v-spacer/>

      <v-icon @click="closeModal()">
        mdi-close
      </v-icon>
    </v-toolbar>
    <v-card-text>
      <v-form lazy-validation
              ref="formAutoStart"
              v-model="valid">
        <v-row>
          <v-col cols="12">
            Canal: <b style="text-transform: capitalize">Whatsapp</b>
          </v-col>

          <v-col cols="12">
            <CountryPicker color="kbGreen"
                           outlined
                           v-model="country">
            </CountryPicker>
          </v-col>

          <v-col cols="12">
            <v-text-field @blur="cleanPhone"
                          color="kbGreen"
                          @keypress="checkKeyOnlyNumbers($event)"
                          label="Celular"
                          maxlength="12"
                          outlined
                          :rules="[rules.required]"
                          v-model="phone">
              <template v-slot:prepend-inner>
                <span style="margin-top: 3px">+{{country.number}}</span>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-select :items="selectedChannel.templates"
                      item-text="template"
                      placeholder="Seleccione una plantilla"
                      outlined
                      return-object
                      v-model="selectedTemplate">
            </v-select>
          </v-col>

          <v-col cols="12">
            {{text}}
          </v-col>

          <v-col cols="12"
                 :key="item.id"
                 v-for="item in selectedTemplate.params">
            <v-text-field :placeholder="`Ingrese ${item.name}`"
                          :rules="[rules.required]"
                          v-model="item.value">
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider/>

    <v-card-actions>
      <v-spacer/>

      <v-btn @click="closeModal()"
             color="error"
             text>
        Cancelar
      </v-btn>

      <v-btn @click="submit()"
             color="kbGreen"
             dark
             :loading="loading">
        Iniciar
        <v-icon right>
          mdi-send
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CountryPicker from '@/components/ui/CountryPicker'
import rules from '@/libs/rules'
import notifications from '@/libs/notifications'
import countries from '@/libs/countries'
import { mapState } from 'vuex'

export default {
  components: { CountryPicker },
  computed: {
    ...mapState({
      initConversation: state => state.conversations.initConversation
    }),
    text () {
      if (!this.selectedTemplate) return ''

      let text = this.selectedTemplate.text

      if (!this.selectedTemplate.params) return text

      this.selectedTemplate.params.map(item => {
        if (!item.value) return
        text = text.replace(item.name, item.value)
      })
      return text
    }
  },
  data: () => ({
    country: {},
    loading: false,
    phone: '',
    rules,
    selectedTemplate: {},
    showDialog: false,
    valid: true
  }),
  methods: {
    async submit () {
      try {
        if (!this.$refs.formAutoStart.validate()) return

        this.cleanPhone()

        this.loading = true
        const data = {
          access: this.selectedChannel.access,
          channel: this.selectedChannel.channel,
          text: this.text,
          userGuest: `+${this.country.number}${this.phone}`,
          params: this.selectedTemplate.params,
          template: this.selectedTemplate.template
        }

        await this.$store.dispatch('startRoom', data)
        this.closeModal()
        this.loading = false
      } catch (e) {
        this.loading = false
        notifications.error(e)
      }
    },
    autocompleteData () {
      this.phone = this.initConversation.phone
      const selectedCountry = this.initConversation.country.toLowerCase()
      this.country = countries.find(element => {
        return element.code === selectedCountry
      })

      this.$store.commit('SET_INIT_CONVERSATION', null)
    },
    checkKeyOnlyNumbers (event) {
      if (event.keyCode < 48 || event.keyCode > 58) {
        event.preventDefault()
      }
    },
    cleanPhone () {
      this.phone = this.phone.replace(/[^0-9]/g, '')
    },
    closeModal () {
      this.$refs.formAutoStart.reset()
      this.$emit('close')
    }
  },
  mounted () {
    if (this.initConversation) this.autocompleteData()
  },
  props: ['selectedChannel']
}
</script>
